export enum SuggestedFaqFieldsNames {
  QUESTION = 'question',
  ANSWER = 'answer',
}

export type TSuggestedFaqFormValues = {
  [SuggestedFaqFieldsNames.QUESTION]: string;
  [SuggestedFaqFieldsNames.ANSWER]: string;
};

export enum ApproveFaqFieldsNames {
  IS_GENERAL = 'isGeneral',
  CHANNEL_IDS = 'channelIds',
}

export type TApproveFaqFormValues = {
  [ApproveFaqFieldsNames.IS_GENERAL]: boolean;
  [ApproveFaqFieldsNames.CHANNEL_IDS]?: number[];
};
